import { withStyles } from "@material-ui/core/styles";
import LockIcon from "@material-ui/icons/Lock";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import consts from "../../main/consts";
import nav from "../../main/navigationConfig";
import { getLabelOrigem, getListOrigens } from "../../main/origem";
import { getRowsAndTotal } from "../../state/order/actions";
import { salesChannelIsAmericanas } from "../../utils/check-sales-channel";
import { deliveryNumber } from "../../utils/fields/formatters";
import ContentTable from "./ContentTable";
import {
	getTimeStr,
	getTimeWithHourStr,
} from "./helpers";
import PreSaleIcon from "./icons/PreSaleIcon";

const styles = (theme) => ({
	totalCost: {
		minWidth: 130,
		fontWeight: "bold",
	},
	warning: {
		width: 10,
	},
	circle: {
		display: "inline-block",
		width: 26,
		height: 26,
		padding: 3,
		backgroundColor: () => theme.palette.pages["new-orders"],
		borderRadius: 20,
		"& .icon": {
			color: "white",
		},
	},
	maxWidthCol: {
		maxWidth: 170,
		[theme.breakpoints.down("sm")]: {
			maxWidth: "inherit",
		},
	},
	duracao: {
		textTransform: "lowercase",
	},
	capitalize: {
		textTransform: "capitalize",
	},
});

const getHeaders = (classes) => [
	{
		title: "Nº Pedido",
		align: "left",
		dataField: "codigoExterno",
		class: classes.maxWidthCol,
		render: (codigoExterno) => codigoExterno.split("#")[0],
	},
	{
		title: "Pré-venda",
		align: "left",
		dataField: "preVenda",
		class: classes.maxWidthCol,
		render: (preVenda) => {
			if (preVenda) {
				return <PreSaleIcon />;
			}
			return null;
		},
	},
	{
		title: "Nº Entrega",
		align: "left",
		dataField: "entregas",
		class: classes.maxWidthCol,
		render: (entregas) => deliveryNumber(entregas[entregas.length - 1].codigo),
	},
	{
		title: "Origem",
		align: "left",
		dataField: "origem",
		filter: "origem",
		filterOptions: getListOrigens(),
		render: (data) => getLabelOrigem(data),
	},
	{
		title: "Data",
		align: "left",
		dataField: "dataInclusao",
		render: (data) => new Date(data).toLocaleDateString(),
	},
	{
		title: "Entrega estimada",
		align: "left",
		dataField: "dhEntregaEstimada",
		render: (data, row) =>
			salesChannelIsAmericanas(row.canalDeVendas)
				? getTimeStr(data)
				: getTimeWithHourStr(data),
	},
	{
		title: "Cliente",
		align: "left",
		dataField: "cliente",
		class: classes.capitalize,
		render: (data) => data && data.nome.toLowerCase(),
	},
	{
		title: "Canal de venda",
		align: "left",
		dataField: "canalDeVendas",
		render: (data) => data,
	},
	{
		title: "Total",
		align: "right",
		class: classes.totalCost,
		render: () => <LockIcon style={{ color: "#0000008a" }} />,
	},
];

const PAGE_NAME = "estimated";
const ROWS_PER_PAGE = consts.ROWS_PER_PAGE;
class Previstos extends React.Component {
	componentDidMount() {
		this.loadGridData(0, ROWS_PER_PAGE);
	}

	componentDidUpdate(prevProps) {
		console.log("::debug-componentDidUpdate-[Previstos.jsx]");
		const {
			loja,
			orders: { filters },
			limit,
		} = this.props;
		if (
			loja !== prevProps.loja ||
			filters !== prevProps.orders.filters ||
			prevProps.limit !== limit
		) {
			this.loadGridData(0, ROWS_PER_PAGE, true);
		}
	}

	loadGridData = (page, limits, avoidSpinner = false) => {
		const {
			getRowsAndTotal,
			orders: { filters },
			limit,
		} = this.props;
		limits = limits || ROWS_PER_PAGE;

		const navigationIndexByPageId = nav.findIndex((item) => item.id === PAGE_NAME);

		getRowsAndTotal({
			page,
			limit: limit,
			filters: {
				...filters,
				status: nav[navigationIndexByPageId].status.join(),
				ordemDataInclusao: "asc",
			},
			avoidSpinner,
			pageId: PAGE_NAME,
		});
	};

	clickRow = (row) => {
		this.props.history.push(`${consts.CONTEXT}/estimated/${row.numero}`, {
			data: { page: PAGE_NAME },
		});
	};

	render() {
		return (
			<ContentTable
				loaded={this.props.orders.loaded}
				limit={this.props.limit}
				title="Pedidos Previstos"
				subtitle="Pedidos em pré-venda passam para <strong>Novo Pedido</strong> um dia antes do lançamento. Acompanhe o volume para planejar a operação."
				page={PAGE_NAME}
				headers={getHeaders(this.props.classes)}
				onClickRow={this.clickRow}
				hideLegendas
				rows={this.props.orders.grids[PAGE_NAME].rows}
				total={this.props.orders.grids[PAGE_NAME].total}
				store={this.props.orders.grids[PAGE_NAME].store}
				selectedPage={this.props.orders.page}
				rowsPerPage={ROWS_PER_PAGE}
				showPaginator={false}
				onHandlePageChange={this.loadGridData}
				selectedOrigemFilter={getLabelOrigem(
					this.props.orders.grids[PAGE_NAME].selectedFilter,
				)}
			/>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		orders: state.orders,
		loja: state.auth.loja,
		limit: state.orders.limit,
		reRender: state.orders.reRender,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators({ getRowsAndTotal }, dispatch);
export default compose(
	withStyles(styles),
	connect(mapStateToProps, mapDispatchToProps),
)(Previstos);
